import BundleConfigurator from "./component-library183.mjs";
import SingleItemConfigurator from "./component-library184.mjs";
import "./component-library185.mjs";
import normalizeComponent from "./component-library95.mjs";
const _sfc_main = {
  name: "OfferConfigurator",
  components: {
    BundleConfigurator,
    SingleItemConfigurator
  },
  props: {
    focusedItemIndex: {
      type: Number,
      default: void 0
    },
    bundleItems: {
      type: Array,
      default: () => []
    }
  },
  emits: ["select-variant"],
  computed: {
    firstBundleItem() {
      return this.bundleItems[0] || {};
    },
    isBundle() {
      return this.bundleItems.length > 1 || this.firstBundleItem.isMerged;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _vm.isBundle || _vm.firstBundleItem ? _c("div", { staticClass: "offer-configurator" }, [_vm.isBundle ? _c("BundleConfigurator", { attrs: { "focused-item-index": _vm.focusedItemIndex, "bundle-items": _vm.bundleItems }, on: { "select-variant": (args) => _vm.$emit("select-variant", args) } }) : _c("SingleItemConfigurator", { attrs: { "bundle-item": _vm.firstBundleItem }, on: { "select-variant": (args) => _vm.$emit("select-variant", args) } })], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const index = __component__.exports;
export {
  index as default
};
